import { useContext } from "react";
import { BuilderUIContext } from "@circle-react-shared/BuilderUI/Provider/BuilderUIProvider";
import { BuilderTextRenderer } from "./BuilderTextRenderer";
import { StaticTextRenderer } from "./StaticTextRenderer";
import type { TextRendererProps } from "./TextRenderer.types";

export const TextRenderer = (props: TextRendererProps) => {
  const builderContext = useContext(BuilderUIContext);
  return builderContext ? (
    <BuilderTextRenderer {...props} />
  ) : (
    <StaticTextRenderer {...props} />
  );
};
